import React from 'react';
import { useTranslation, Trans } from "react-i18next";

function PageItem({
  name,
  access_token: token,
  onCopy,
}) {
  const { t } = useTranslation();

  return (
    <div className="page-item">
      <h3>Token for <strong>{name}</strong></h3>
      <code>{token}</code>
      <button onClick={onCopy}>{t('Copy to Clipboard')}!</button>
    </div>
  )
}

function TokenPresenter({
  loading,
  success,
  name,
  pictureUrl,
  pages,
  error,
  onGenerate,
  onCopy,
  onReload,
}) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <section>{t('Loading')}...</section>
    )
  }

  if (error) {
    return (
      <section>
        <p className="error">
          {t('Ops! Something went wrong')}: <span className="normal-weight">{t(error.message)}</span>
        </p>
        <p>
          <Trans i18nKey="text.reloadToTryAgain">
            If you wanna try again, please <a href="#" onClick={onReload}>reload</a> this page.
          </Trans>
        </p>
      </section>
    )
  }

  if (success) {
    return (
      <section>
        <p>
          {t('Congratulations')}, <strong>{name}</strong>! <img alt={name} className="profile-pic" src={pictureUrl} />
        </p>
        <p>
          {t('Your tokens were successfully generated', { count: 1 + pages.length })}:
        </p>
        {
          pages.map((page) => (
            <PageItem {...page} onCopy={() => onCopy(page.access_token)} />
          ))
        }

        <p>
          <Trans i18nKey="text.facebook.revoke-note">
            You can revoke this authorization at any time from your Facebook account <a href="https://www.facebook.com/settings?tab=business_tools">settings</a>.
          </Trans>
        </p>
      </section>
    )
  }

  return (
    <section>
      <p>
        <Trans i18nKey="text.facebook.introduction">
          In order to see your pages' posts on Facebook being automatically displayed in Digital Signage Screens powered
          by <a href="https://dsplay.tv">DSPLAY - Digital Signage</a>, you need to generate a Token
          which provides <i>read-only</i> access to your pages' Facebook <i>Basic Profile</i> and <i>Posts</i>.
        </Trans>
      </p>
      <p>
        <Trans i18nKey="text.facebook.explanation">
          After clicking on the button below, this page will redirect you to Facebook, where you will be asked to authorize <span className="normal-weight">DSPLAY - Digital Signage</span> to
          read your basic data from your Facebook pages.
        </Trans>
      </p>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button className="main" onClick={onGenerate}>{t('Generate Facebook Token(s)')}</button>
      </div>
      <p>
        <Trans i18nKey="text.facebook.conclusion">
          If everything went well, you'll be brought back to this page with your Token(s) ready.
          You can revoke this authorization at any time from your Facebook account <a href="https://www.facebook.com/settings?tab=business_tools">settings</a>.
        </Trans>
      </p>
    </section>

  )

}

export default TokenPresenter;